<template>
  <div id="app">
    <Menu data-test-id="MenuComponent" />
    <Error data-test-id="ErrorComponent" />
    <div class="container position-relative">
      <router-view />
    </div>
    <FeedbackModal data-test-id="FeedbackFormComponent" />
    <Version data-test-id="VersionComponent" />
  </div>
</template>

<script lang="ts">
import { mapActions, mapGetters } from "vuex";
import { Menu, Error, Version } from "@/App/components";
import { FeedbackModal } from "@/App/components";
import Vue from "vue";

export default Vue.extend({
  name: "App",
  components: {
    Menu,
    Error,
    Version,
    FeedbackModal
  },
  computed: {
    ...mapGetters("Login", ["selectedEMSAgency"])
  },
  mounted() {
    this.$store.watch(
      () => this.selectedEMSAgency,
      newAgency => this.fetchAgencyRelatedData(newAgency)
    );
    this.bootstrapInitialState();
  },
  methods: {
    ...mapActions("Trucks", { loadTrucks: "loadData" }),
    ...mapActions("Users", { loadUsers: "loadData" }),
    ...mapActions("Cases", { loadCases: "loadData", loadMonthlyData: "loadMonthlyData" }),
    ...mapActions("Login", ["setSelectedEMSAgency", "loadGlobalAdminAgencies", "setHotjarIdentity"]),
    bootstrapInitialState() {
      const selectedEMSAgencyCache = JSON.parse(localStorage.getItem("selectedEMSAgency") || "null");
      const user = JSON.parse(localStorage.getItem("user") || "null");

      if (user) {
        const { displayName, email, id: userID, username } = user;

        this.setHotjarIdentity({ displayName, email, userID, username });
      }

      if (selectedEMSAgencyCache) {
        this.setSelectedEMSAgency(selectedEMSAgencyCache);
      }

      if (user && user.isAdmin) {
        this.loadGlobalAdminAgencies();
      }
    },
    fetchAgencyRelatedData(agency) {
      if (agency) {
        Promise.all([
          this.loadTrucks(agency.id),
          this.loadUsers(agency.id),
          this.loadCases(agency.id),
          this.loadMonthlyData(agency.id)
        ]);
      }
    }
  }
});
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
